import type { FC, PropsWithChildren } from 'react'
import { useMemo } from 'react'
import type { Document } from '@contentful/rich-text-types'
import styled from '@emotion/styled'

import RichText from '@segment/matcha/recipes/RichText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

interface ContentProps {
  data: Document
}
const Content: FC<PropsWithChildren<ContentProps>> = ({ data }) => {
  const content = useMemo(() => {
    if (!data) {
      return
    }

    return <RichText data={data} />
  }, [data])

  return (
    <Wrapper>
      <StyledSectionBase variant="centered">
        <Section.Contents>
          <StyledArticle>{content}</StyledArticle>
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

export default Content

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.neutrals.white[100]};
`

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 0;
  }
`

const StyledArticle = styled.article`
  max-width: 844px;
  margin: auto;

  > *:first-child {
    margin-top: 0;
  }
`
